enum Period {
  BEFORE_MATCH = 1,
  FIRST_HALF = 2,
  HALF_TIME = 3,
  SECOND_HALF = 4,
  PAUSE_BEFORE_EXTRA_TIME = 5,
  FIRST_HALF_EXTRA_TIME = 6,
  HALF_TIME_EXTRA_TIME = 7,
  SECOND_HALF_EXTRA_TIME = 8,
  PAUSE_BEFORE_PENALTIES_SHOOTOUT = 9,
  PENALTIES_SHOOTOUT = 30,
  AFTER_MATCH = 31,
}

export enum PeriodSorting {
  FIRST_HALF = 2,
  HALF_TIME = 3,
  SECOND_HALF = 4,
  FIRST_HALF_EXTRA_TIME = 22,
  HALF_TIME_EXTRA_TIME = 23,
  SECOND_HALF_EXTRA_TIME = 24,
}

export default Period;
